import { createStyles, makeStyles } from "@material-ui/core";
import React, { useEffect, useState } from "react";
import { hosts } from "../../../yoello-lib/modules/host/Hosts";
import { Trans, useTranslation } from "react-i18next";
import { useSignup } from "../state/SelfSignup";

const useStyles = makeStyles((theme) => createStyles({
    root: {
        color: "#616161",
        padding: '0.25rem',
        marginTop: '1rem'
    },
    email: {
        color: '#212121',
        fontWeight: 600,
        margin: '1.25rem 0 1.25rem 0'
    },
    resendEmail: {
        color: theme.palette.text.secondary,
        fontSize: '0.9rem',
        cursor: 'pointer',
        paddingTop: '1rem'
    },
    checkEmail: {
        "& span": {
            fontWeight: "600"
        }
    },
    resendHyperLink: {
        color: theme.palette.secondary.main
    }
}))


export function SignupCompleted() {
    const classes = useStyles();
    const { userData, removeSnapshot, completeSignup, leadData, host } = useSignup();
    const { t } = useTranslation();
    const [canResend, setCanResend] = useState(false);
    const isPartners = host === "partners";
    const canResendEmail = host !== hosts.zerobubble && host !== hosts.bna;
    useEffect(() => {
        removeSnapshot();
        completeSignup().then(() => setCanResend(canResendEmail));
        //eslint-disable-next-line
    }, []);

    function onResendEmail() {
        completeSignup();
    }

    return <div className={classes.root}>
        <div>
            {t('signup.completed.successEmailText')}
        </div>
        <div className={classes.email}>
            {!isPartners ? leadData?.contact_email : userData?.contact_email}
        </div>
        {canResendEmail && <div className={classes.checkEmail}>
            <Trans i18nKey="signup.completed.successCheckEmail"
                components={{ bold: <span /> }}
            />
        </div>}
        <div onClick={onResendEmail} className={classes.resendEmail}>
            {canResend && <Trans
                i18nKey="signup.completed.resendEmail">
                0 <span className={classes.resendHyperLink}>1</span>
            </Trans>}
        </div>
    </div>
}